import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { makeDefaultFailedContainer } from 'components/container'
import ReplyTable from 'components/settings/reply/ReplyTable'
import { Button } from '@driftt/tide-core-legacy'
import { Link } from 'react-router'
import { isEmpty } from 'ramda'
import InlineSVG from 'svg-inline-react'
import ConditionalRender from 'components/shared/ConditionalRender'
import 'styles/components/settings/reply/ManageSavedReplies.styl'

import EMPTY_TABLE_SRC from '!svg-inline?removeSVGTagAttrs=false?removeTags=true!./blank_table.svg'


class ManageSavedReplies extends Component {

  static contextTypes = {
    router: PropTypes.object.isRequired
  }

  onNewReplyClick = () => {
    return this.context.router.push('/settings/replies/compose/new')
  }

  onModalClose = () => {
    this.context.router.push('/settings/replies')
  }

  onReplySaved = () => {
    this.context.app.queries.SavedReplyQueries.fetchReplies()
    this.context.router.push('/settings/replies')
  }

  onDeleteReply = (replyId) => {
    this.app.actions.SavedReplyActions.deleteReply(replyId)
  }

  render() {
    const { replies } = this.props
    const hasReplies = !isEmpty(replies)

    return (
      <div className="ManageSavedReplies">
        <Link to="/settings/conversations">
          {'< Conversations Settings'}
        </Link>

        <h1 className="settings-saved-replies-title">
          Saved Replies
        </h1>

        <p className="settings-saved-replies-description">
          Saved replies are great for a quick response to questions that you get often.
          Write something up and send it to a visitor with one click.
          <a href="https://help.drift.com/article/how-to-create-saved-replies-/" target="_blank">
            Learn More
          </a>
        </p>

        <Button
          className="settings-saved-replies-new"
          onClick={this.onNewReplyClick}>
          New Reply
        </Button>

        <ConditionalRender
          condition={!hasReplies}
          className="settings-saved-replies-empty">
          <InlineSVG src={EMPTY_TABLE_SRC} />
        </ConditionalRender>

        <ConditionalRender
          condition={hasReplies}
          className="settings-saved-replies-table">
          <ReplyTable
            replies={replies}
            onDeleteReply={this.onDeleteReply}
          />
        </ConditionalRender>

        { this.props.children && React.cloneElement(
            this.props.children, {
              onClose: this.onModalClose,
              onSave: this.onReplySaved
            })
        }
      </div>
    )
  }
}

export default makeDefaultFailedContainer(ManageSavedReplies, {
  listenTo: ['stores.SavedReplyStore'],
  fetch: {
    replies() {
      return this.app.stores.SavedReplyStore.fetchReplyListSorted()
    }
  }
})



// WEBPACK FOOTER //
// ./src/scripts/components/settings/reply/ManageSavedReplies.js